import React from "react";
import { useDispatch } from "react-redux";
import MultiButton from "../../../Docuclipper/MultiButton";
import {
  ToolType,
  TemplateFieldV2,
} from "../../../../docuclipper/DocuclipperTypes";

import {
  updateTemplateField,
  setNumColumns,
  fetchExtractedData,
  fieldSectionSetExpanded,
} from "../../../../redux/reducers/TemplateField";
import { withSelectedField } from "./withSelectedField";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { useMedia } from "react-media";
import { GLOBAL_MEDIA_QUERIES } from "../../../../utils/media";

type Props = {
  field: TemplateFieldV2;
};
export const _ToolTypeSelector: React.SFC<Props> = ({ field }) => {
  const dispatch = useDispatch();

  const selected: ToolType = field.toolType;

  const matches = useMedia({ queries: GLOBAL_MEDIA_QUERIES });

  let spanClass = "20";
  if (matches.small) {
    spanClass = "w20";
  } else if (matches.medium) {
    spanClass = "w20";
  } else if (matches.large) {
    spanClass = "w35";
  }

  return (
    <>
      {/* <div className="h5">Tool type</div> */}
      <MultiButton
        spanClassName={spanClass}
        btnClassName=""
        selected={selected}
        onSelect={(option) => {
          const value = option.apiName;
          let toolType: ToolType = value as ToolType;
          dispatch(
            updateTemplateField({
              id: field.id,
              update: {
                toolType,
              },
            })
          );
          dispatch(fetchExtractedData({ id: field.id }));
          if (["tables", "ocrtables"].includes(toolType)) {
            dispatch(
              fieldSectionSetExpanded({
                name: "tableConfig",
                expanded: true,
              })
            );
            dispatch(setNumColumns({ id: field.id, numColumns: 2 }));
          }
        }}
        options={[
          {
            text: "Text",
            apiName: "ocr",
            icon: "font" as IconProp,
            tooltip: () => <span>Text</span>,
          },
          {
            text: "Table",
            apiName: "ocrtables",
            icon: "table" as IconProp,
            tooltip: () => <span>Table</span>,
          },
          {
            text: "Handwriting",
            apiName: "handwriting",
            icon: "pencil-alt" as IconProp,
            tooltip: () => <span>Handwriting</span>,
          },
          {
            text: "Checkbox",
            apiName: "checkbox",
            icon: "check" as IconProp,
            tooltip: () => <span>Checkbox</span>,
          },
        ]}
      />
    </>
  );
};

export const ToolTypeSelector = withSelectedField(_ToolTypeSelector);
